import type { Partner } from "@expert/shared-types";

import { useQuery } from "@tanstack/react-query";

import type { SalesAnalyticsDispatcher } from "../../../../../sales-context/SalesContext.types";
import type { CustomerDetailsPayload } from "../../../../../types";

import { useSalesContext } from "../../../../../sales-context/SalesContext";
import { getCustomerDetails } from "../customer-info/getCustomerDetails";

interface UseGetCustomerDetailsByBANParams {
    billingAccountNumber: string;
    pin: string;
    partner: Partner;
    dispatcher?: SalesAnalyticsDispatcher;
    customerDetailsCallback?: (result: CustomerDetailsPayload) => void;
    mdn?: string;
}

export function useGetCustomerDetailsByBAN({
    billingAccountNumber,
    pin,
    partner,
    dispatcher,
    customerDetailsCallback,
    mdn,
}: UseGetCustomerDetailsByBANParams) {
    const { logger, apiClients } = useSalesContext();
    const childLogger = logger.child({ module: "useGetCustomerDetailsByBAN" });

    const { data, isLoading, refetch } = useQuery({
        queryKey: [`customer-details-${billingAccountNumber}-${pin}`, billingAccountNumber + pin],
        queryFn: async () => {
            return getCustomerDetails(apiClients.customer, childLogger, {
                billingAccountNumber,
                pin: pin.length > 0 ? pin : undefined,
                partner,
                searchType: "billingAccountNumberAndPin",
                dispatcher,
                customerDetailsCallback,
                modelResultsMdn: mdn,
            });
        },
        enabled: false,
        refetchOnMount: true,
    });

    return {
        data,
        isLoading,
        refetch,
    };
}
